module.exports = __webpack_public_path__ + "img/custom-8.75fb1b95.svg";